export const ROLES = Object.freeze({
    ADMIN: "infuzion-admin",
    JUDGE: "infuzion-judge"
});